import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'antd';
import { shutdownAlisaAudioQuery } from '../../../../../../../../shared/api/queries';
import { GenerateAlisaAudio } from '../../../../../../generateAlisaAudio';
import { AlisaAudioControl } from '../../../../../../../../shared/lib/alisaAudioManager';
import { fieldNames } from '../../../../../config';

const { useShutdownAlisaAudio } = shutdownAlisaAudioQuery;

const Actions = ({ form }) => {
  const [generateDisabled, setGenerateDisabled] = useState(true);
  const [playDisabled, setPlayDisabled] = useState(true);

  const { WorkerId } = useSelector((state) => state.authentication.userInfo);
  const workerIdTemp = `${WorkerId}_temp`;
  const { data: audioData, isFetching: isAudioFetching } =
    useShutdownAlisaAudio(workerIdTemp);

  const handleGenerateSuccess = useCallback(() => {
    setGenerateDisabled(true);
    setPlayDisabled(false);
  }, []);

  const alisaText = form.getFieldValue(fieldNames.alisaText);

  useEffect(() => {
    setGenerateDisabled(!alisaText?.trim());
    setPlayDisabled(true);
  }, [alisaText]);

  let generateLoading = false;

  const isPlayDisabled =
    playDisabled ||
    generateLoading ||
    isAudioFetching ||
    (!isAudioFetching && !audioData);

  return (
    <>
      <GenerateAlisaAudio
        onGenerateSuccess={handleGenerateSuccess}
        render={({ onClick, loading }) => {
          generateLoading = loading;
          return (
            <Button
              disabled={generateDisabled || loading}
              loading={loading}
              onClick={() =>
                onClick({ shutdownId: workerIdTemp, text: alisaText?.trim() })
              }
            >
              Сгенерировать аудио
            </Button>
          );
        }}
      />

      <AlisaAudioControl
        render={({ onPlay, onStop, playingShutdownId }) => {
          const isPlaying = playingShutdownId === workerIdTemp;
          return (
            <Button
              disabled={isPlayDisabled}
              loading={isAudioFetching}
              onClick={
                isPlaying
                  ? onStop
                  : () =>
                      onPlay({
                        shutdownId: workerIdTemp,
                        audioData: audioData.slice(),
                      })
              }
            >
              {playingShutdownId === workerIdTemp ? 'Остановить' : 'Прослушать'}
            </Button>
          );
        }}
      />
    </>
  );
};

export default Actions;
